import React from 'react';
import 'yuki-createjs';
import { connect } from 'react-redux';
import Char from './Char';
import CharBtn from './CharBtn';
import RestartBtn from './RestartBtn';
import TraceOnBtn from './TraceOnBtn';
import TraceOffBtn from './TraceOffBtn';
import GuidelinesOnBtn from './GuidelinesOnBtn';
import GuidelinesOffBtn from './GuidelinesOffBtn';
import { setSpacing } from '../../../utils/utils';

const charWatchTrack = (WrappedComponent, charType, animType) => {
    class CharWatchTrack extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                total: 5,
                array: [],
                isPlaying: true,
                guidelinesShown: true
            };

            createjs.Ticker.on('tick', this.tick, this);
            createjs.Ticker.framerate = 30;
        }
        load() {
            this.state.loader = new createjs.LoadQueue(true);
            this.state.loader.on('complete', this.create, this);

            this.state.manifest = [{ 
                src: 'images/sections/' + charType + '/chars/' + animType + '/' + this.state.char + '.json', 
                id: charType + '-' + animType + '-spritesheet',
                type: 'spritesheet'
            }];

            while (this.state.manifest.length > 0) {
                this.state.loader.loadFile(this.state.manifest.shift());
            }
        }
        create() {
            let _this = this;

            for (var i = 0; i < this.state.total; i++) {
                let cvs = document.getElementById(charType + '-' + animType + '-cvs-' + i);

                this.state.array[i] = new Object();
                this.state.array[i].canvas = cvs;
                this.state.array[i].stage = new createjs.Stage(this.state.array[i].canvas);
                this.state.array[i].anim = new createjs.Sprite(this.state.loader.getResult(charType + '-' + animType + '-spritesheet'));
                this.state.array[i].anim.id = i;

                this.state.array[i].stage.addChild(this.state.array[i].anim);
                this.state.array[i].anim.on('animationend', this.end, this);
                
                if (animType === 'track') {

                    this.state.array[i].btn = $('.char-btn', '#' + charType + '-' + animType);
                    this.state.array[i].btn.on('touchstart mousedown', function() {

                        let id = parseInt($(this).attr('id'));

                        _this.state.array[id].anim.play();

                        $('body').on('touchend mouseup', function() {

                            _this.state.array[id].anim.stop();

                            $('body').off('touchend mouseup');
                        });
                    });
                }
            }

            if (animType === 'watch') {
                if (this.state.isPlaying) {
                    this.play();
                }
            }

            $(window).on('resize.' + charType + '-' + animType, function() {
                _this.resize();
            });

            this.resize();
        }
        end(e) {
            if (animType === 'track') {
                e.target.gotoAndPlay('active');
            } else {
                e.target.stop();

                if (e.target.id < (this.state.total - 1)) {
                    this.state.array[e.target.id + 1].anim.gotoAndPlay('active');
                } else {
                    for (var i = 0; i < this.state.total; i++) {
                        this.state.array[i].anim.gotoAndStop('inactive');
                    }
                    this.state.array[0].anim.gotoAndPlay('active');
                }
            }
        }
        tick() {
            if (this.state.array.length) {
                for (var i = 0; i < this.state.total; i++) {
                    if (this.state.array[i].stage !== undefined) {
                        this.state.array[i].stage.update();
                    }
                }
            }
        }
        pos() {
            const holder = $('.holder-inner', '#' + charType + '-' + animType),
                holderBaseW = 380;

            let holderBaseH = 104,
                holderBaseRatio = 0.8;
            
            if (charType === 'uc') {
                holderBaseH = 82;
                holderBaseRatio = 0.56;
            }

            let char = $('.char-holder', '#' + charType + '-' + animType),
                charBtn = $('.char-btn', '#' + charType + '-' + animType),
                holderW = holder.width(),
                holderH = holder.height(),
                holderPercW = holderW / 100,
                holderPercH = holderH / 100,
                spaceW = (this.state.spacing[1] + this.state.spacing[3]) * holderBaseRatio,
                spaceT = this.state.spacing[2] * holderBaseRatio,
                spaceH = this.state.spacing[4] * holderBaseRatio,
                btnTopPerc = (spaceT/holderBaseH) * 100,
                btnTopOffsetPerc = (6 / holderBaseH) * 100,
                btnTop = (holderPercH * btnTopPerc) - (btnTopOffsetPerc * holderPercH),
                btnBaseW = (this.state.spacing[3] + 4) * holderBaseRatio,
                btnW = holderPercW * ((btnBaseW/holderBaseW) * 100), 
                btnH = holderPercH * ((spaceH/holderBaseH) * 100),
                xPos = holderPercW * 3.5,
                xInc = holderPercW * ((spaceW/holderBaseW) * 100);

            if (charType === 'uc') {
                btnW = holderPercW * ((btnBaseW/holderBaseW) * 100 + 2);
                btnH = holderPercH * ((spaceH/holderBaseH) * 100 + 12);
            }

            for (var i = 0; i < this.state.total; i++) {
                char.eq(i).css('left', xPos + 'px');

                if (animType === 'track') {
                    charBtn.eq(i).css({
                        'top': btnTop + 'px',
                        'left': xPos + 'px',
                        'width': btnW + 'px',
                        'height': btnH + 'px'
                    });
                }

                xPos += xInc;
            }
        }
        resize() {
            const parent = $('.char-holder'),
                curr = $('.' + charType + '-' + animType + '-cvs');
            let parentW = parent.width(),
                parentH = parent.height(),
                currW = curr.width(),
                currH = curr.height(),
                scale = parentW / currW;

            curr.attr('height', $('#' + charType + '-' + animType).height() - $('.holder', '#' + charType + '-' + animType).position().top);
            
            for (var i = 0; i < this.state.total; i++) {
                this.state.array[i].stage.scaleX = scale;
                this.state.array[i].stage.scaleY = scale;
            }

            this.pos();
        }
        play() {
            this.stop();
            if (this.state.array.length) {
                
                this.state.array[0].anim.gotoAndPlay('active');
            }
            this.setState({ isPlaying: true });
        }
        stop() {
            if (this.state.array.length) {
                for (var i = 0; i < this.state.total; i++) {
                    this.state.array[i].anim.gotoAndStop('active');
                }
            }
            this.setState({ isPlaying: false });
        }
        guidelinesShow() {
            $('.guidelines', '#' + charType + '-' + animType).show();
            this.setState({ guidelinesShown: true });
        }
        guidelinesHide() {
            $('.guidelines', '#' + charType + '-' + animType).hide();
            this.setState({ guidelinesShown: false });
        }
        componentWillReceiveProps(nextProps) {
            if (nextProps.char) {
                this.state.char = nextProps.char;
                this.state.spacing = setSpacing(nextProps.char, charType);

                this.setState({ isPlaying: true });
                this.guidelinesShow();

                if (nextProps.char === 'm' || nextProps.char === 'w' || nextProps.char === 'M' || nextProps.char === 'W' || nextProps.char === '10') {
                    this.setState({ total: 4 });
                }
                else {
                    this.setState({ total: 5 });
                }

                this.load();
            }
        }
        componentWillUnmount() {
            $(window).off('resize.' + charType + '-' + animType);
        }
        render() {
            let btn,
                controls,
                arrow;
            if (animType === 'track') {
                btn = 
                    [...Array(this.state.total)].map((label, index) => {
                        return (
                            <CharBtn key={index} id={index} />
                        );
                    });
                controls = 
                    (
                        <RestartBtn onClick={this.stop.bind(this)} />
                    );
                arrow = '';
            }
            else {
                btn = '';
                controls = 
                    (
                        <div>
                            <div className="trace-txt"></div>
                            <TraceOffBtn onClick={this.stop.bind(this)} selected={!this.state.isPlaying} />
                            <TraceOnBtn onClick={this.play.bind(this)} selected={this.state.isPlaying} />
                        </div>
                    );
                arrow = (<div className="panel-arrow-d"></div>);
            }
            return (
                <div id={charType + '-' + animType} className={'char-' + animType + ' panel'}>
                    <div className="title"></div>
                    {arrow}
                    <div className="guidelines-txt"></div>
                    <GuidelinesOffBtn onClick={this.guidelinesHide.bind(this)} selected={!this.state.guidelinesShown} />
                    <GuidelinesOnBtn onClick={this.guidelinesShow.bind(this)} selected={this.state.guidelinesShown} />
                    {controls}
                    <div className="holder">
                        <div className="holder-inner">
                            {btn}
                            {[...Array(this.state.total)].map((label, index) => {
                                return (
                                    <Char key={index} id={index} charType={charType} animType={animType} />
                                );
                            })}
                        </div>
                        <div className="guidelines"></div>
                    </div>
                </div>
            );
        }
    };

    const mapStateToProps = (state) => ({
        char: state.char.char
    })

    return connect(mapStateToProps, undefined)(CharWatchTrack);
}

export default charWatchTrack;



// WEBPACK FOOTER //
// ./src/components/sections/shared/CharWatchTrack.js